<script setup lang="ts">
  import type { HTMLAttributes } from "vue";
  import { cn } from "@/lib/utils";
  import { computed, type Component } from "vue";
  import {
    Undo2,
    Redo2,
    Bold,
    Italic,
    Heading1,
    Heading2,
    Heading3,
    Pilcrow,
    List,
    ListOrdered,
  } from "lucide-vue-next";

  const props = defineProps<{
    name: string;
    size?: "sm" | "md" | "lg";
    class?: HTMLAttributes["class"];
  }>();

  // Map icon names (including mdi: prefix) to Lucide components
  const iconMap: Record<string, Component> = {
    "mdi:undo": Undo2,
    "mdi:redo": Redo2,
    "mdi:format-bold": Bold,
    "mdi:format-italic": Italic,
    "mdi:format-header-1": Heading1,
    "mdi:format-header-2": Heading2,
    "mdi:format-header-3": Heading3,
    "mdi:format-paragraph": Pilcrow,
    "mdi:format-list-bulleted": List,
    "mdi:format-list-numbered": ListOrdered,
  };

  const iconComponent = computed(() => iconMap[props.name] || null);

  // Compute size classes
  const sizeClasses = computed(() => {
    switch (props.size) {
      case "sm":
        return "h-4 w-4";
      case "lg":
        return "h-6 w-6";
      default:
        return "h-5 w-5";
    }
  });

  // Log a warning if the icon is not found
  if (!iconComponent.value) {
    console.warn(`TiptapIcon: Icon "${props.name}" not found in icon map`);
  }
</script>

<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    :class="cn(sizeClasses, props.class)"
    data-slot="tiptap-icon" />
  <span
    v-else
    :class="cn(sizeClasses, props.class)"
    data-slot="tiptap-icon">
    ?
  </span>
</template>
